<template>
  <div class="d-flex">
    <b>{{ label }}</b>
    <div class="ml-1">{{ value }}</div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped></style>
